import './HeaderSettings.scss';

export { default } from './HeaderSettings';
